<template>
  <div class="item flex flex-cross-center" :class="{checked}" @click="click">
    <span v-if="selectable" class="checkbox"></span>
    <span class="name flex-1">{{item.name}}</span>
    <span class="amount flex-1">{{item.amount}}</span>
    <span class="flex-1 t-c">
      <span class="tag">{{item.tag}}</span>
    </span>
    <span class="date flex-1">{{item.date|format('yyyy-MM-dd')}}</span>
  </div>
</template>
<script>
import { format } from '@/utils'
export default {
  props: {
    item: Object,
    selectable: Boolean,
    checked: Boolean
  },
  filters: {
    format
  },
  methods: {
    click () {
      if (this.selectable) {
        this.$emit('change', !this.checked)
      } else {
        this.$emit('click')
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "./var.styl"
.item
  height 44px
  padding 0 12px
  border-bottom 1px solid $color-text-disabled
  &:first-child
    border-top 1px solid $color-text-disabled
  &.checked
    .checkbox
      border-color $color-primary
      &::before
       border-color transparent transparent $color-primary $color-primary
  .checkbox
    position relative
    width 16px
    height @width
    line-height @height
    margin-right 32px
    font-size 12px
    text-align center
    border 1px solid $color-text-minor
    border-radius 50%
    &::before
      position absolute
      content ''
      left 2px
      top 4px
      width 10px
      height 5px
      border-style solid
      border-color transparent
      border-width 1px
      transform rotate3D(0, 0, 1, -45deg)
  .name
    color $color-text-highlight
  .amount
    color $color-primary
  .tag
    padding 2px 6px
    border-radius 4px
    color #8081e7
    background-color lighten(@color, 70%)
    border 1px solid @color
  .date
    color $color-text-minor
    text-align right
</style>



// WEBPACK FOOTER //
// GiftItem.vue?17b0e0fe